import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Header from "../Components/Header";
import "./OrderDetails.css";
import axios from "axios";
import API_BASE from "../config";

const OrderDetails = () => {
  const { id } = useParams();
  const { state } = useLocation();

  const navigate = useNavigate();

  const [order, setOrder] = useState(null);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrderDetails();
  }, []);

  const fetchOrderDetails = async () => {
    try {
      setLoading(true);

      const token = sessionStorage.getItem("token");

      const response = await axios.get(
        `${API_BASE}/order/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setOrder(response.data);
      setStatus(response.data.status);
    } catch (error) {
      console.log("Error fetching order details:", error);
    } finally {
      setLoading(false);
    }
  };

  const [updatingStatus, setUpdatingStatus] = useState(false);

  const updateOrderStatus = async (newStatus) => {
    try {
      setUpdatingStatus(true);

      const token = sessionStorage.getItem("token");

      await axios.put(
        `${API_BASE}/order/${id}/status`,
        {
          status: newStatus,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setStatus(newStatus);

      setOrder((prev) => ({
        ...prev,
        status: newStatus,
      }));

    } catch (error) {
      console.log("Error updating status:", error);

      alert("Failed to update order status");
    } finally {
      setUpdatingStatus(false);
    }
  };

  if (loading) {
    return (
      <div className="orderdetails-page">
        <Header />
        <h2 style={{ padding: "20px" }}>Loading order details...</h2>
      </div>
    );
  }

  if (!order) {
    return (
      <div className="orderdetails-page">
        <Header />
        <h2 style={{ padding: "20px" }}>No Order Found</h2>
      </div>
    );
  }

  return (
    <div className="orderdetails-page">
      <Header />

      <div className="orderdetails-top">
        {/* LEFT SIDE */}
        <div className="orderdetails-top-left">
          <span
            onClick={() => navigate(-1)}
            className="orderdetails-back-btn"
          >
            ←
          </span>

          <div>
            <h2>Order Details</h2>
            <p>Order {order.orderNumber}</p>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <button className="orderdetails-invoice-btn">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
            fill="#FFFFFF"
          >
            <path d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z" />
          </svg>
          Download Invoice
        </button>
      </div>

      <div className="orderdetails-card orderdetails-row3">
        <div>
          <p>Order ID</p>
          <h4>{order.orderNumber}</h4>
        </div>

        <div>
          <p>Order Date</p>
          <h4>
            {new Date(order.orderDate).toLocaleDateString("en-IN", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })}
          </h4>
        </div>

        <div>
          <p>Status</p>

          <span
            className={`orderdetails-status orderdetails-${status.toLowerCase()}`}
          >
            {status}
          </span>
        </div>
      </div>

      {/* CUSTOMER INFO */}
      <div className="orderdetails-card">
        <h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
            fill="#BB271A"
          >
            <path d="M367-527q-47-47-47-113t47-113q47-47 113-47t113 47q47 47 47 113t-47 113q-47 47-113 47t-113-47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm296.5-343.5Q560-607 560-640t-23.5-56.5Q513-720 480-720t-56.5 23.5Q400-673 400-640t23.5 56.5Q447-560 480-560t56.5-23.5ZM480-640Zm0 400Z" />
          </svg>
          Customer Information
        </h3>

        <div className="orderdetails-box">
          <p>Name: {order.customerName}</p>
          <p>Phone: {order.phone}</p>
          <p>Email: {order.email}</p>
        </div>
      </div>

      {/* SHIPPING */}
      <div className="orderdetails-card">
        <h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M16.6666 8.33341C16.6666 12.4942 12.0508 16.8276 10.5008 18.1659C10.3564 18.2745 10.1806 18.3332 9.99992 18.3332C9.81925 18.3332 9.64348 18.2745 9.49909 18.1659C7.94909 16.8276 3.33325 12.4942 3.33325 8.33341C3.33325 6.5653 4.03563 4.86961 5.28587 3.61937C6.53612 2.36913 8.23181 1.66675 9.99992 1.66675C11.768 1.66675 13.4637 2.36913 14.714 3.61937C15.9642 4.86961 16.6666 6.5653 16.6666 8.33341Z"
              stroke="#F4C2C2"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10 10.8333C11.3807 10.8333 12.5 9.71396 12.5 8.33325C12.5 6.95254 11.3807 5.83325 10 5.83325C8.61929 5.83325 7.5 6.95254 7.5 8.33325C7.5 9.71396 8.61929 10.8333 10 10.8333Z"
              stroke="#F4C2C2"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Shipping Address
        </h3>

        <div className="orderdetails-box">{order.address}</div>
      </div>

      {/* ORDER ITEMS */}
      <div className="orderdetails-card">
        <h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M9.16667 18.1084C9.42003 18.2547 9.70744 18.3317 10 18.3317C10.2926 18.3317 10.58 18.2547 10.8333 18.1084L16.6667 14.7751C16.9198 14.6289 17.13 14.4188 17.2763 14.1658C17.4225 13.9127 17.4997 13.6257 17.5 13.3334V6.66675C17.4997 6.37448 17.4225 6.08742 17.2763 5.83438C17.13 5.58134 16.9198 5.37122 16.6667 5.22508L10.8333 1.89175C10.58 1.74547 10.2926 1.66846 10 1.66846C9.70744 1.66846 9.42003 1.74547 9.16667 1.89175L3.33333 5.22508C3.08022 5.37122 2.86998 5.58134 2.72372 5.83438C2.57745 6.08742 2.5003 6.37448 2.5 6.66675V13.3334C2.5003 13.6257 2.57745 13.9127 2.72372 14.1658C2.86998 14.4188 3.08022 14.6289 3.33333 14.7751L9.16667 18.1084Z"
              stroke="#D4AF37"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Order Items
        </h3>

        {order.items?.map((item, index) => (
          <div className="orderdetails-item-box" key={index}>
            <img
              src={
                state?.image ||
                "https://via.placeholder.com/100"
              }
              alt=""
            />

            <div>
              <h4>{item.productName}</h4>
              <p>Quantity: {item.quantity}</p>
            </div>

            <h3>₹{item.subTotal}</h3>
          </div>
        ))}

        <div className="orderdetails-bill">
          <p>
            Subtotal <span>₹{order.totalAmount}</span>
          </p>

          <p>
            Shipping <span>₹{order.shippingAmount}</span>
          </p>

          <h4>
            Total{" "}
            <span>
              ₹
              {Number(order.totalAmount) +
                Number(order.shippingAmount)}
            </span>
          </h4>
        </div>
      </div>

      {/* PAYMENT */}
      <div className="orderdetails-card">
        <h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M16.6667 4.16675H3.33341C2.41294 4.16675 1.66675 4.91294 1.66675 5.83341V14.1667C1.66675 15.0872 2.41294 15.8334 3.33341 15.8334H16.6667C17.5872 15.8334 18.3334 15.0872 18.3334 14.1667V5.83341C18.3334 4.91294 17.5872 4.16675 16.6667 4.16675Z"
              stroke="#9810FA"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1.66675 8.33325H18.3334"
              stroke="#9810FA"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Payment Method
        </h3>

        <div className="orderdetails-box">
          <p>{order.paymentMethod}</p>
          <small>{order.paymentNumber}</small>
        </div>
      </div>

      {/* STATUS BUTTONS */}
      {/* STATUS BUTTONS */}
      <div className="orderdetails-status-grid">
        {[
          "Pending",
          "Shipped",
          "Delivered",
          "Cancelled",
        ].map((item) => (
          <button
            key={item}
            disabled={updatingStatus}
            className={`orderdetails-${item.toLowerCase()} ${status === item ? "active" : ""
              }`}
            onClick={() => updateOrderStatus(item)}
          >
            {updatingStatus && status === item
              ? "Updating..."
              : item}
          </button>
        ))}
      </div>
    </div>
  );
};

export default OrderDetails;